import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  DialogActions,
  Box,
  Paper,
  Typography,
  IconButton,
} from "@mui/material";
import { useWindows } from "../../hooks/useWindows";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

const FunctionForm = ({ open, handleClose, onSubmit, defaultValues = {} }) => {
  const { windows: allWindows } = useWindows();
  const { register, handleSubmit, reset } = useForm({ defaultValues });

  const [associatedWindows, setAssociatedWindows] = useState([]);
  const [availableWindows, setAvailableWindows] = useState([]);

  useEffect(() => {
    if (open) {
      reset(defaultValues);

      const ventanasAsociadas = Array.isArray(defaultValues?.ventanas)
        ? defaultValues.ventanas
            .filter((id) => id !== null && id !== undefined)
            .map((id) => allWindows?.find((w) => w.venid === id))
            .filter((w) => w !== undefined)
        : [];

      setAssociatedWindows(ventanasAsociadas);
      setAvailableWindows(
        allWindows
          ? allWindows.filter(
              (w) => !ventanasAsociadas.some((v) => v.venid === w.venid)
            )
          : []
      );
    }
  }, [open, defaultValues, reset, allWindows]);

  const handleFormClose = () => {
    reset();
    handleClose();
  };

  // 🔹 Agregar ventana desde "Disponibles" a "Asociadas"
  const handleAddWindow = (id) => {
    const windowToAdd = availableWindows.find((w) => w.venid === id);
    if (windowToAdd) {
      setAssociatedWindows((windows) => [...windows, windowToAdd]);
      setAvailableWindows((windows) => windows.filter((w) => w.venid !== id));
    }
  };

  // 🔹 Quitar ventana desde "Asociadas" a "Disponibles"
  const handleRemoveWindow = (id) => {
    const windowToRemove = associatedWindows.find((w) => w.venid === id);
    if (windowToRemove) {
      setAvailableWindows((windows) => [...windows, windowToRemove]);
      setAssociatedWindows((windows) => windows.filter((w) => w.venid !== id));
    }
  };

  const handleFormSubmit = (data) => {
    if (associatedWindows.length === 0) {
      alert("Debe asociar al menos una ventana para crear la función.");
      return;
    }
    const ventanas = associatedWindows.map((w) => w.venid);
    onSubmit({ ...data, ventanas });
  };

  return (
    <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="md">
      <DialogTitle>
        {defaultValues?.funid ? "Editar Función" : "Crear Función"}
      </DialogTitle>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <DialogContent>
          <TextField label="Nombre de la Función" fullWidth margin="normal" {...register("funnom")} />
          <TextField label="Descripción de la Función" fullWidth margin="normal" {...register("fundes")} />

          <Box display="flex" gap={2} mt={2}>
            {/* 📌 Ventanas Asociadas */}
            <Paper sx={{ flex: 1, p: 2, backgroundColor: "#f9f9f9", borderRadius: 2, boxShadow: 3 }}>
              <Typography variant="h6" gutterBottom>
                Ventanas Asociadas
              </Typography>
              {associatedWindows.map((window) => (
                <Box key={window.venid} display="flex" justifyContent="space-between" alignItems="center" width="100%" sx={{ p: 1, mb: 1, borderRadius: 2, backgroundColor: "#fff", boxShadow: 1 }}>
                  <Typography>{window.vennom}</Typography>
                  <IconButton color="error" onClick={() => handleRemoveWindow(window.venid)}>
                    <RemoveCircleIcon />
                  </IconButton>
                </Box>
              ))}
            </Paper>

            {/* 📌 Ventanas Disponibles */}
            <Paper sx={{ flex: 1, p: 2, backgroundColor: "#f9f9f9", borderRadius: 2, boxShadow: 3 }}>
              <Typography variant="h6" gutterBottom>
                Ventanas Disponibles
              </Typography>
              {availableWindows.map((window) => (
                <Box key={window.venid} display="flex" justifyContent="space-between" alignItems="center" width="100%" sx={{ p: 1, mb: 1, borderRadius: 2, backgroundColor: "#fff", boxShadow: 1 }}>
                  <Typography>{window.vennom}</Typography>
                  <IconButton color="primary" onClick={() => handleAddWindow(window.venid)}>
                    <AddCircleIcon />
                  </IconButton>
                </Box>
              ))}
            </Paper>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleFormClose}>Cancelar</Button>
          <Button type="submit" variant="contained">
            {defaultValues?.funid ? "Actualizar" : "Guardar"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default FunctionForm;
